import { action } from 'typesafe-actions';
import { THeaderTabOption, UIActionTypes } from './types';
import { ToastProps } from '@chakra-ui/react';

export const changeHeaderTab = (tab: THeaderTabOption) => action(UIActionTypes.SET_HEADER_TAB, tab);

export const updateConnection = (status: boolean) => action(UIActionTypes.UPDATE_CONNECTION_STATUS, status);

export const setScrollRowIndex = (idx: number) => action(UIActionTypes.UPDATE_SCROLL_INDEX, { idx });

export const closeModal = () => action(UIActionTypes.CLOSE_MODAL);

export const openDocumentModal = (
  sponsorType: string,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle?: string,
) =>
  action(UIActionTypes.OPEN_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
  });

export const openFinanceDocumentModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle?: string,
) =>
  action(UIActionTypes.OPEN_FINANCE_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
  });

export const openFollowUpDocumentModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle?: string,
  data?: any,
) =>
  action(UIActionTypes.OPEN_FOLLOW_UP_DOCUMENT_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    ...data,
  });

export const openUploadModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle: string,
  fileNames: string[],
  metadata?: any,
) =>
  action(UIActionTypes.OPEN_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata,
  });

export const openUploadFinanceModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle: string,
  fileNames: string[],
  metadata?: any,
) =>
  action(UIActionTypes.OPEN_FINANCE_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata,
  });

export const openUploadFollowUpModal = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  modalTitle: string,
  fileNames: string[],
  metadata?: any,
) =>
  action(UIActionTypes.OPEN_FOLLOW_UP_UPLOAD_MODAL, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    modalTitle,
    fileNames,
    metadata,
  });

export const openUploadInterviewModal = (
  interviewType: string,
  eventType: string,
  eventKey: string,
  modalTitle: string,
  fileNames: string[],
) =>
  action(UIActionTypes.OPEN_INTERVIEW_UPLOAD_MODAL, {
    interviewType,
    eventType,
    eventKey,
    modalTitle,
    fileNames,
  });

export const openUploadRecordedInterviewModal = (
  interviewType: string,
  interviewHash: string,
  attemptHash: string,
  modalTitle: string,
  fileNames: string[],
) =>
  action(UIActionTypes.OPEN_RECORDED_INTERVIEW_UPLOAD_MODAL, {
    interviewType,
    interviewHash,
    attemptHash,
    modalTitle,
    fileNames,
  });

export const deleteFile = (fileName: string) =>
  action(UIActionTypes.DELETE_FILE, {
    fileName,
  });
export const setIsLoading = (isLoading: boolean) =>
  action(UIActionTypes.SET_IS_LOADING, {
    isLoading,
  });

export const setContextLoading = isLoading => action(UIActionTypes.SET_CONTEXT_LOADING, { isLoading });

export const setContextSuccess = (sagaContext = null) => action(UIActionTypes.SET_CONTEXT_SUCCESS, { sagaContext });
export const openToast = (toastProps: ToastProps) => action(UIActionTypes.OPEN_TOAST_MESSAGE, toastProps);
export const clearToast = () => action(UIActionTypes.CLEAR_TOAST_MESSAGE);
